"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   query GetOrganisation($organisationId: String!) {\n    getOrganisation(organisationId: $organisationId) {\n      organisationId\n      name\n      alias\n      imageUrl\n      industry\n      contentRegion\n      billingEntityCode\n      location {\n        country\n        unit\n        street\n        citySuburb\n        state\n        postCode\n      }\n      notes\n      socialProfiles {\n        website\n        facebook\n        twitter\n        linkedIn\n        other\n      }\n      parentOrganisation {\n        name\n      }\n      accountManager {\n        userId\n        firstName\n        lastName\n        officeLocation\n        department\n        imageUrl\n      }\n      bdm {\n        userId\n        firstName\n        lastName\n        officeLocation\n        department\n        imageUrl\n      }\n      defaultUser {\n        userId\n        firstName\n        lastName\n        email\n        phoneNumber\n        workNumber\n        linkedInUrl\n        officeLocation\n        department\n        jobTitle\n        imageUrl\n      },\n      invitedUserEmail,\n      contractUrl\n      package {\n        iconName\n        videoQuantity\n        slaTurnaround\n        amendmentsQuantity\n        resetPeriod\n        userAllowance\n        storageAllowance\n        custom\n        templatedFrom\n        subStart\n        subEnd\n        includedAddonTypes\n      }\n      equipment {\n        miniKits\n        bigKits\n      }\n      editingTeamId,\n      status\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _default = (0, _graphqlTag.default)(_templateObject());

exports.default = _default;